import {gql} from 'apollo-angular';


export const constituentEventsGql = gql`
query produceReloadConstituentEventsGql($individualConstituentId: [Int!]) {
    IndividualConstituent(individualConstituentId: $individualConstituentId) {
        fundraisingParticipantItems {
            participantId
            eventId
            eventName
            date
            eventDate
            eventTime
            timezone
            programName
            programGroupName
            fiscalYear
            pastFundraiser
        }
    }
}
`;